import React, { useEffect, useState, useRef } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";
import Promotions from "@/components/Pages/Finance/PageSavings/Promotions";
import AllProducts from "@/components/Pages/Finance/PageSavings/AllProducts";
// import DurationSelect from "../DurationSelect";

export default observer(() => {
  const t = useTranslation();
  const { finance } = useStore();

  return (
    <div className={styles.main}>
      <Promotions />
      <AllProducts />
    </div>
  );
});
